export default __webpack_public_path__ + "static/IBMPlexSans-Text-Cyrillic-598773c25dc32d2006ea0be94c793676.woff";